import { ResourceProps } from 'react-admin';
import icon from '@material-ui/icons/Build';
import create from './create';
import edit from './edit';
import list from './list';

const utilities: ResourceProps = {
  name: 'utilities',
  icon,
  options: { label: 'Serviços' },
  create,
  edit,
  list
};

export default utilities;
